export default __webpack_public_path__ + "dc2f1974ba42dffe0b84adae6c28c460.gif";